/*!
 * Copyright 2024 - Swiss Data Science Center (SDSC)
 * A partnership between École Polytechnique Fédérale de Lausanne (EPFL) and
 * Eidgenössische Technische Hochschule Zürich (ETHZ).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Returns a new URL instance or null if `url` is not a valid URL string. */
export function safeNewUrl(
  url: URL | string | undefined | null,
  base?: URL | string | undefined,
): URL | null {
  if (url == null) {
    return null;
  }
  try {
    return new URL(url, base);
  } catch (error) {
    if (error instanceof TypeError) {
      return null;
    }
    throw error;
  }
}
